<template>
    <div>
        <nav class="breadcrumbWrapper" aria-label="breadcrumb">
            <ol :class="['breadcrumb', color]">
                <li class="breadcrumb-item" v-for="crumb in this.crumbs" v-bind:key="crumb.route">
                    <router-link :to="crumb.route">{{crumb.name}}</router-link>
                    <span class="breadcrumb-separator">&raquo;</span>
                </li>
                <li class="breadcrumb-item active">{{this.$route.meta.breadCrumb}}</li>
                <router-link v-if="!this.firstPI" :class="['back-btn', color]"
                             :to="this.previousPage">
                    <li class="breadcrumb-separator">&laquo;</li>
                    <li>Zurück</li>
                </router-link>

            </ol>
        </nav>
    </div>
</template>

<script>
    export default {
        name: "BreadCrumb",
        props: {
            color: {
                default: 'black',
                required: false
            }
        },
        data: function () {
            return {
                previousPage: '',
                firstPI: false
            };
        },
        computed: {
            crumbs: function () {
                let parentRoutes = this.$route.meta.parents;
                for (let i = 0; i < parentRoutes.length; i++) {
                    if (typeof this.$route.params.id !== 'undefined' && (parentRoutes[i].name === 'Kampagnenansicht' || parentRoutes[i].name === 'Kampagne')) {
                        parentRoutes[i].route = '/campaigns/'+this.$route.params.id;
                    }else if (typeof this.$route.params.id !== 'undefined') {
                        parentRoutes[i].route = parentRoutes[i].route.replace(':id', this.$route.params.id)
                    }
                }

                return parentRoutes;
            }
        },
        created() {
            if (typeof this.$root.redirectedFrom !== 'undefined' && this.$root.redirectedFrom !== '') {
                this.previousPage = this.$root.redirectedFrom;
                this.firstPI = false;
            } else {
                this.firstPI = true;
                this.previousPage = '/';
            }

        }
    }
</script>

<style lang="scss" scoped>

    ol.breadcrumb {
        margin-block-start: 0em;
    }

    .breadcrumb {
        font-size: 10px;
        text-align: left;
        margin-bottom: 0px !important;
        padding: 8px 15px 8px 0px;
        list-style: none;
        border-radius: 4px;
    }

    .breadcrumb > li {
        display: inline-block;
        text-transform: uppercase;
    }

    .breadcrumb > li > a {
        text-decoration: none;
        color: #000;
    }

    .breadcrumb.white > li > a {
        text-decoration: none;
        color: #fff;
    }

    .breadcrumb > li.active {
        color: #000;
        font-weight: bold;
        cursor: default;
    }

    .breadcrumb.white > li.active {
        color: #fff;
        font-weight: bold;
        cursor: default;
    }

    .breadcrumb-separator {
        padding-left: .6em;
        padding-right: .6em;
    }

    .back-btn {
        font-weight: bold;
        float: right;
        text-decoration: none;
        color: #000;
        text-transform: uppercase;

        &.white {
            color: #fff;
        }
    }

    .back-btn > li {
        font-size: 10px;
        display: inline-block;
    }
</style>